import React from 'react';
import classNames from 'classnames';

import './styles.css';

const FormField = ({children, className}: any) => {
  return <div className={classNames('FormField', className)}>{children}</div>;
};

export default FormField;
